module.exports = __webpack_public_path__ + "static/media/logo.4846bd30.png";